/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_View_Edit_TitleInputs */

const en_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View/Edit Notes`)
};

const fr_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir/Modifier les notes`)
};

const de_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen ansehen/bearbeiten`)
};

const it_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza/modifica note`)
};

const ru_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотреть/редактировать заметки`)
};

const es_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver/Editar notas`)
};

const zh_cn2_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看/编辑笔记`)
};

const ja_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモの表示/編集`)
};

const hi_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स देखें/संपादित करें`)
};

const pt_pt2_event_notes_view_edit_title = /** @type {(inputs: Event_Notes_View_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver/Editar notas`)
};

/**
* | output |
* | --- |
* | "View/Edit Notes" |
*
* @param {Event_Notes_View_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_view_edit_title = /** @type {((inputs?: Event_Notes_View_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_View_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_notes_view_edit_title(inputs)
	if (locale === "de") return de_event_notes_view_edit_title(inputs)
	if (locale === "it") return it_event_notes_view_edit_title(inputs)
	if (locale === "ru") return ru_event_notes_view_edit_title(inputs)
	if (locale === "es") return es_event_notes_view_edit_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_notes_view_edit_title(inputs)
	if (locale === "ja") return ja_event_notes_view_edit_title(inputs)
	if (locale === "hi") return hi_event_notes_view_edit_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_notes_view_edit_title(inputs)
	return en_event_notes_view_edit_title(inputs)
});